export const Env = {
    ...{
        production: false,
        baseUrl: "https://backoffice-dev-api.mahfza.com/api/",
        tanant: "4c565587-f8c1-4c40-b8a8-763c61704cf4"
    }, // any custom env config here
    // --------------------------------------------------------------------
    // base env config here (this imported as separate JS script in Angular.Json as separated script)
    ... (window as any).bootstrapConfigSettings
}